import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer1',
  templateUrl: './footer1.component.html',
  styleUrls: ['./footer1.component.css']
})
export class Footer1Component implements OnInit {
  year:any;
  constructor() { }

  ngOnInit(): void {
    const d = new Date();
    this.year = d.getFullYear();
  }

}
